import { callZigzagFunction } from '../../callZigzagFunction';
import { SavedProduct, SavedProductStatus } from '../../types';
import { zigzagHandler } from '../../handlers';

// 내 상품 삭제
export const rsp = (savedProduct: SavedProduct) => {
  return new Promise<SavedProductStatus>(resolve => {
    callZigzagFunction('rsp')(savedProduct);
    zigzagHandler('onSavedProductStatus', savedProductStatusList => {
      resolve(savedProductStatusList[0]);
    });
  });
};
